import Report from '../../../../../../models/components/report/Report';

const getPreviewContent = ({ header, footer }: Report) => [header, footer].find(Boolean);

export default getPreviewContent;